import type { CommercialTemplateDefinition } from '../types'

/**
 * Quick-start commercial templates — assemble a quote in under a minute.
 */
export const COMMERCIAL_TEMPLATES: CommercialTemplateDefinition[] = [
  {
    id: 'tpl-pc-escritorio',
    name: 'PC Escritório',
    description: 'Desktop básico para escritório (Ryzen 5 + 16GB + 500GB)',
    itemType: 'Computer',
    itemName: 'Computador Escritório',
    componentCatalogIds: {
      cpu: 'cmp-cpu-r5-5600',
      motherboard: 'cmp-mb-b550m',
      ram: 'cmp-ram-16-3200',
      storage: 'cmp-ssd-500',
      gpu: 'cmp-gpu-integrated',
      psu: 'cmp-psu-550',
      case: 'cmp-case-matx',
      cooler: 'cmp-cooler-stock',
    },
    tags: ['desktop', 'office', 'fast'],
  },
  {
    id: 'tpl-pc-gamer',
    name: 'PC Gamer Entrada',
    description: 'Desktop gamer com RTX 4060',
    itemType: 'Computer',
    itemName: 'Computador Gamer Entrada',
    componentCatalogIds: {
      cpu: 'cmp-cpu-i5-12400f',
      motherboard: 'cmp-mb-b660m',
      ram: 'cmp-ram-32-3200',
      storage: 'cmp-ssd-1tb',
      gpu: 'cmp-gpu-rtx4060',
      psu: 'cmp-psu-650',
      case: 'cmp-case-matx',
    },
    tags: ['desktop', 'gamer', 'fast'],
  },
  {
    id: 'tpl-notebook-office',
    name: 'Notebook Escritório',
    description: 'Notebook pronto para produtividade',
    itemType: 'Notebook',
    catalogId: 'nb-office-15',
    tags: ['notebook', 'office', 'fast'],
  },
  {
    id: 'tpl-monitor-24',
    name: 'Monitor 24"',
    description: 'Monitor IPS Full HD',
    itemType: 'Monitor',
    catalogId: 'mon-24-ips',
    tags: ['monitor', 'fast'],
  },
  {
    id: 'tpl-kit-perifericos',
    name: 'Kit periféricos',
    description: 'Teclado + mouse wireless',
    itemType: 'Peripheral',
    catalogId: 'per-kb-mouse',
    tags: ['peripheral', 'fast'],
  },
  {
    id: 'tpl-montagem',
    name: 'Serviço de montagem',
    description: 'Montagem e testes do desktop',
    itemType: 'Service',
    catalogId: 'svc-montagem',
    tags: ['service', 'desktop', 'fast'],
  },
]

export class CommercialTemplateRegistry {
  private readonly templates: CommercialTemplateDefinition[]

  constructor(templates: CommercialTemplateDefinition[] = COMMERCIAL_TEMPLATES) {
    this.templates = templates
  }

  list(tag?: string): CommercialTemplateDefinition[] {
    if (!tag) return [...this.templates]
    return this.templates.filter((t) => t.tags.includes(tag))
  }

  get(id: string): CommercialTemplateDefinition | undefined {
    return this.templates.find((t) => t.id === id)
  }
}

export const commercialTemplates = new CommercialTemplateRegistry()
